import {
  calculateColumnWidth,
  mapColumnTypes,
  selectColumnFactory,
  TYPES,
} from "@/react/components/table";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema from "./schema";
import * as yup from "yup";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(schema.fields.subscriptionId, "Subscription ID"),
        type: TYPES.ID,
      },
      {
        ...getColumnDef(schema.fields.extensionNumber, "Extension"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.callerIdFirstName, "First Name"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.callerIdLastName, "Last Name"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.primaryDID, "Primary Did"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.maxConcurrentCalls"),
          "Max Concurrent Calls"
        ),
        type: TYPES.NUMBER,
        editable: true,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
